import { useState } from 'react'
import { Button, Stack, Text, TextInput } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import { ActionButton, AppModal } from '@/components/ui'
import { api, ApiError } from '@/lib/api'
import { notifyProjectsChanged } from '@/lib/projects-events'
import type { ProjectRow } from '@/types/api'

type Props = {
  opened: boolean
  onClose: () => void
  project: ProjectRow | null
  onDeleted?: () => void
}

export function ProjectDeleteModal({ opened, onClose, project, onDeleted }: Props) {
  const [confirmText, setConfirmText] = useState('')
  const [deleting, setDeleting] = useState(false)

  const name = project?.name ?? ''
  const canDelete = confirmText.trim() === name && name.length > 0

  const remove = async () => {
    if (!project || !canDelete) return
    setDeleting(true)
    try {
      await api.projectDelete(project.id, name)
      showNotification({ title: 'Проект удалён', message: '', color: 'green' })
      notifyProjectsChanged()
      setConfirmText('')
      onClose()
      onDeleted?.()
    } catch (e) {
      showNotification({
        title: 'Ошибка',
        message: e instanceof ApiError ? e.message : 'Не удалось удалить',
        color: 'red',
      })
    } finally {
      setDeleting(false)
    }
  }

  return (
    <AppModal
      opened={opened}
      onClose={() => {
        setConfirmText('')
        onClose()
      }}
      title="Удалить проект"
      size="md"
      footer={
        <>
          <ActionButton action="cancel" onClick={onClose} />
          <Button color="red" loading={deleting} disabled={!canDelete} onClick={() => void remove()}>
            Удалить
          </Button>
        </>
      }
    >
      <Stack gap="sm">
        <Text size="sm">
          Удалятся обращения, каналы, метки и связанные данные. Введите точное название проекта для подтверждения:
        </Text>
        <Text fw={600} size="sm">
          «{name}»
        </Text>
        <TextInput
          placeholder="Название проекта"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          autoComplete="off"
        />
      </Stack>
    </AppModal>
  )
}
